import { Col, Row } from 'react-bootstrap';
import LabelRequired from 'src/app/modules/component/LabelRequired';
import { APP_DATE_TIME_FORMAT } from 'src/app/modules/utils/Constant';
import { formatDateTime } from 'src/app/modules/utils/FormatUtils';

type Props = {
	data: any;
};

const ThongTinPhieu = ({ data }: Props) => {
	const formatDateField = (value: any) => {
		return value ? formatDateTime(value, APP_DATE_TIME_FORMAT) : '...';
	};

	return (
		<div className="px-3 py-1 bg-white border-bottom border-bottom-2">
			<Row>
				<Col xs={4} className="d-flex align-items-center mb-3">
					<LabelRequired label="Mã phiếu:" className="spaces min-w-110" />
					<span className="fw-light text-truncate">{data?.code || '...'}</span>
				</Col>
				<Col xs={4} className="d-flex align-items-center mb-3">
					<LabelRequired label="Ngày y lệnh:" className="spaces min-w-110" />
					<span className="fw-light text-truncate">
						{formatDateField(data?.indicationTime)}
					</span>
				</Col>
				<Col xs={4} className="d-flex align-items-center mb-3">
					<LabelRequired label="Người chỉ định:" className="spaces min-w-110" />
					<span className="fw-light text-truncate">
						{data?.indicationPerson || '...'}
					</span>
				</Col>
			</Row>

			<Row>
				<Col xs={4} className="d-flex align-items-center mb-3">
					<LabelRequired label="Nơi chỉ định:" className="spaces min-w-110" />
					<span className="fw-light text-truncate">{data?.requestDeptName || '...'}</span>
				</Col>
				<Col xs={8} className="d-flex align-items-center mb-3">
					<LabelRequired label="Chẩn đoán:" className="spaces min-w-110" />
					<span className="fw-light text-truncate">
						{data?.provisionalDiagnosisName || '...'}
					</span>
				</Col>
			</Row>
		</div>
	);
};

export default ThongTinPhieu;
